import logo_nodejs from './../logo/icons8-nodejs.svg';
import logo_python from './../logo/icons8-python.svg';
import logo_react from './../logo/icons8-react-native.svg';
import logo_excel from './../logo/icons8-microsoft-excel.svg';
import logo_mysql from './../logo/icons8-mysql-logo.svg';
import logo_php from './../logo/icons8-php-48.png';
import logo_javascript from './../logo/icons8-javascript.svg';
import french_icon from './../logo/icons8-france-48.png';
import usa_icon from './../logo/icons8-usa-48.png';
import spanish_icon from './../logo/icons8-spain-48.png';
import german_icon from './../logo/icons8-germany-48.png';
import logo_tirlun from './../logo/tirlun.svg';
import logo_postgresql from './../logo/icons8-postgresql-96.png';
import logo_eu from './../logo/icons8-flag-of-europe-48.png';
import logo_linkedin from './../logo/icons8-linkedin-2-48.png';
import logo_mail from './../logo/icons8-mail-50.png';
import logo_udacity from './../logo/udacity.png';
import logo_quantic from './../logo/quantic.png';
import logo_cfi from './../logo/cfi.jpeg';
import logo_bielefeld from './../logo/uni-bielefeld.png';
import logo_placeholder from './../logo/diamond.png';
import logo_hfc from './../logo/hfc.png';
import logo_gatech from './../logo/gatech.png';
import logo_draperuniversity from './../logo/draperuniversity.png';
import logo_goskilling from './../logo/goskilling.png';
import logo_location from './../logo/icons8-location-50.png';
import { Centrify } from '../layout/elements';
const contact = [
  {
    id: 1,
    label: "EU Work Authorization",
    value: "Eligible to work across the EU",
    logo: logo_eu,
  },
  {
    id: 2,
    label: "Email",
    value: "kramp dot christian (at) gmail dot com",
    logo: logo_mail,
    href: "mailto:kramp.christian@gmail.com",
  },
  {
    id: 3,
    label: "LinkedIn",
    value: "linkedin.com/in/krampchristian",
    logo: logo_linkedin,
    href: "https://linkedin.com/in/krampchristian",
  },
  {
    id: 4,
    label: "Current Location",
    value: "Tallinn, Estonia",
    logo: logo_location,

  },
];

export function ContactOverview() {
  return (
    <Centrify>
      <div className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-4 sm:mt-10 lg:max-w-none lg:grid-cols-2 lg:gap-8">
        {contact.map((item) => (
          <div
            key={item.id}
            className="flex gap-x-4 rounded-xl bg-white/5 p-2 ring-1 ring-inset ring-white/10"
          >
            <img className="h-8 w-8" src={item.logo} alt="" />
            <div className="text-sm leading-6">
              <div className="font-semibold text-gray-600">{item.label}</div>
              {item.href ? (
                <a
                  href={item.href}
                  className="text-gray-700 hover:text-gray-500 transition"
                >
                  {item.value}
                </a>
              ) : (
                <div className="text-gray-700">{item.value}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Centrify>
  );
}

export function About() {
  return <Centrify>
    <h1 className="truncate text-base font-medium text-gray-900 mt-5">About Me</h1>
    <div className="text-gray-800 mx-auto mt-2  gap-6 sm:mt-4 lg:mx-0 lg:max-w-none text-left lg:grid-cols-2 lg:gap-8">
      <p>I’m a systems-minded builder working where data, software, and strategy meet. My background spans social sciences, an Executive MBA, financial modeling, and years of hands-on experience designing technical architectures, workflow engines, and data-driven products.</p>
      <p>I enjoy taking complex problems and turning them into clear, structured solutions — whether that means building AI-assisted recruiting tools, designing psychometric assessment systems, modelling elections, or creating API-first micro-services. My work is driven by curiosity, analytical depth, and a focus on long-term usability.</p>
    </div>
  </Centrify>
}

export function Activities() {
  return <Centrify>
    <h1 className="truncate text-base font-medium text-gray-900 mt-5">Activities</h1>
    <div className="text-gray-800 mx-auto mt-2  gap-6 sm:mt-4 lg:mx-0 lg:max-w-none text-left lg:grid-cols-2 lg:gap-8">
      Writing • Cycling and hiking • Cooking • Gaming (strategy, simulation, sports) • Baseball • Music (country, jazz, rap/hip hop)
    </div>
  </Centrify>

}

function CVEntry({ handle, logo, entity, period, position, grade, preview }) {
  return <li key={handle} className="py-4">
    <div className="flex space-x-3">
      <img className="h-6 w-6 rounded-full" src={logo} alt="" />
      <div className="flex-1 ">
        <div className="flex items-center justify-between">
          <h3 className="text-sm text-gray-600 font-medium">{entity}</h3>
          <p className="text-sm text-gray-600">{period}</p>
        </div>
        <p className="text-gray-800 text-lg font-semibold decoration-4">
          {position}  {grade}
        </p>
        <p className="text-sm text-gray-600">
          {preview}
        </p>
      </div>
    </div>
  </li>
}

const jobs = [
  {
    id: 0,
    position: 'AI Consultant',
    logo: logo_tirlun,
    entity: 'Tirlun AI',
    period: '2024 - present',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      `Helping the agri-tech startup's developer team assessing and defining the right needs based on the product vision and planning the proper implementation. At Tirlun, it was the implementation of tools to analyze and describe videos into standards of procedures (SoPs) for new farm workers who require an onboarding. Tirlun allows farmers to create customized SoPs so that new workers can be training quickly without lacking quality.`,
  },
  {
    id: 1,
    position: 'Founder, Full-Stack Developer, Product Manager',
    logo: logo_goskilling,
    entity: 'GoSkilling',
    period: '2017 - present',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'Fair and sustainable recruiting based on your skills rather than presentation skills.',
  },
  {
    id: 2,
    position: 'Back-End Developer',
    logo: logo_placeholder,
    entity: 'OneLiner',
    period: '2019',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'Working for a Bolder-based startup trying to penetrate the market with a text-based dating app.',
  },
  {
    id: 3,
    position: 'Graphics Designer',
    logo: logo_placeholder,
    entity: 'Freelancer',
    period: '2017 - present',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'Graphics designer working together with a large e-commerce company from the United States. Licensing partnership with NASA, Rust, and Python Software Foundation. Designs are printed on apparel, household goods and sold in the United States, Europe, and Japan.',
  },
  {
    id: 4,
    position: 'Chief Executive Officer, Product Manager',
    logo: logo_placeholder,
    entity: 'Little Rock Online',
    period: '2012 - 2020',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'My first business, initially started in Ireland, then moved to Germany to realize Red Moose.',
  },
]


const education = [
  {
    id: 1,
    position: 'Master of Analytics',
    logo: logo_gatech,
    entity: 'Georgia Institute of Technology',
    period: '2024',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'Started as a new challenge, I had to drop out due to the passing of my mother.',
  },
  {
    id: 2,
    position: 'Master of Business Administration (Executive)',
    logo: logo_quantic,
    entity: 'Quantic School of Business and Technology',
    period: '2021 - 2022',
    grade: 'GPA: 4.0',
    datetime: '2021-01-27T16:35',
    preview:
      'Completed with a high grade despite the passing of my father and caring for my mom sick with cancer. Helped my co-students by preparing and sharing notes - a thousand pages - on every course. Focus on entrepreneurship, blockchain, English business law.',
  },
  {
    id: 3,
    position: 'Fundamentals of Entrepreneurship',
    logo: logo_draperuniversity,
    entity: 'Draper University',
    period: '2020 - 2020',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'Fantastic experience with the class of June 2020 and team "Magic".',
  },
  {
    id: 4,
    position: 'Social Sciences, Sociology (BA)',
    logo: logo_bielefeld,
    entity: 'Bielefeld University',
    period: '2009 - 2014',
    grade: 'GPA: 2.7',
    datetime: '2021-01-27T16:35',
    preview:
      'Focus on labor sociology. Bachelor thesis on Schimank\'s actor theory and the US-subprime crisis. Additionally, completed two courses on U.S: Criminal Law.',
  },
]

const certificates = [
  {
    id: -1,
    position: 'Financial Planning & Wealth Management Professional (FPWM)',
    logo: logo_cfi,
    entity: 'Corporate Finance Institute',
    period: '2024',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 0,
    position: 'FinTech Industry Professional (FiTP)',
    logo: logo_cfi,
    entity: 'Corporate Finance Institute',
    period: '2024',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 1,
    position: 'Commercial Banking & Credit Analyst (CBCA)',
    logo: logo_cfi,
    entity: 'Corporate Finance Institute',
    period: '2023',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 2,
    position: 'Commercial Markets & Securities Analyst (CMSA)',
    logo: logo_cfi,
    entity: 'Corporate Finance Institute',
    period: '2023',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 3,
    position: 'Financial Modeling & Valuation Analyst (FMVA)',
    logo: logo_cfi,
    entity: 'Corporate Finance Institute',
    period: '2019',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 4,
    position: 'Product Manager (Nanodegree)',
    logo: logo_udacity,
    entity: 'Udacity',
    period: '2023',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 5,
    position: 'AI Product Manager (Nanodegree)',
    logo: logo_udacity,
    entity: 'Udacity',
    period: '2023',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 6,
    position: 'Predictive Business Analytics (Nanodegree)',
    logo: logo_udacity,
    entity: 'Udacity',
    period: '2019',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
  {
    id: 7,
    position: 'Business Analytics (Nanodegree)',
    logo: logo_udacity,
    entity: 'Udacity',
    period: '2019',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      '',
  },
]

const volunteering = [
  {
    id: 1,
    position: 'Co-Founder / IT Coordinator',
    logo: logo_hfc,
    entity: 'Heart for Cameroon',
    period: '2017 - 2022',
    grade: '',
    datetime: '2021-01-27T16:35',
    preview:
      'Responsible for the website. Using Wordpress, later React. ',
  },

]

export function CV() {
  return <div className='px-2 sm:px-0'>
    <About/>
    <ContactOverview />
    <Experience />
    <Skills />
    <Languages />
    <Activities />
  </div>
}

export function Experience() {
  return <><Centrify>
    <ul className="divide-y divide-gray-100">
      <h1 className="truncate text-base font-medium text-gray-900">Work</h1>
      <div className='my-5'>
        {jobs.map((job) => (

          <CVEntry handle={job.id} logo={job.logo} entity={job.entity} period={job.period} position={job.position} grade={job.grade} preview={job.preview} />
        ))}
      </div>

      <h1 className="truncate text-base font-medium text-gray-900">Education</h1>
      <div className='my-5'>
        {education.map((school) => (
          <CVEntry handle={school.id} logo={school.logo} entity={school.entity} period={school.period} position={school.position} grade={school.grade} preview={school.preview} />
        ))}
      </div>

      <h1 className="truncate text-base font-medium text-gray-900">Certificates</h1>
      <div className='my-5'>
        {certificates.map((certificate) => (
          <CVEntry handle={certificate.id} logo={certificate.logo} entity={certificate.entity} period={certificate.period} position={certificate.position} grade={certificate.grade} preview={certificate.preview} />
        ))}
      </div>

      <h1 className="truncate text-sm font-medium text-gray-900">Volunteer</h1>
      <div className='my-5'>
        {volunteering.map((volunteer) => (
          <CVEntry handle={volunteer.id} logo={volunteer.logo} entity={volunteer.entity} period={volunteer.period} position={volunteer.position} grade={volunteer.grade} preview={volunteer.preview} />
        ))}
      </div>
    </ul>
  </Centrify>

  </>
}

const skills = [
  {
    name: 'NodeKS',
    handle: 'nodejs',
    imageUrl: logo_nodejs,
  },
  {
    name: 'ReactJS',
    handle: 'reactjs',
    imageUrl: logo_react,
  },
  {
    name: 'MySQL',
    handle: 'mysql',
    imageUrl: logo_mysql,
  },
  {
    name: 'MS Excel',
    handle: 'excel',
    imageUrl: logo_excel,
  },
  {
    name: 'Python',
    handle: 'python',
    imageUrl: logo_python,
  },
  {
    name: 'PHP',
    handle: 'php',
    imageUrl: logo_php,
  },
  {
    name: 'JavaScript',
    handle: 'javascript',
    imageUrl: logo_javascript,
  },
  {
    name: 'PostgreSQL',
    handle: 'postgresql',
    imageUrl: logo_postgresql,
  },
]

export function Skills() {
  return (
    <Centrify>
      <h1 className="truncate text-sm font-medium text-gray-900">Skills</h1>
      <div className="mt-6 flow-root">
        <ul className="-my-5 divide-y divide-gray-200">
          {skills.map((skill) => (
            <li key={skill.handle} className="py-4">
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <img className="h-8 w-8 rounded-full" src={skill.imageUrl} alt="" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-gray-900">{skill.name}</p>
                  {/* <p className="truncate text-sm text-gray-500">{'@' + skill.handle}</p> */}
                </div>
                <div>
                  {/* <a
                    href="#"
                    className="inline-flex items-center rounded-full border border-gray-300 bg-white px-2.5 py-0.5 text-sm font-medium leading-5 text-gray-700 shadow-sm hover:bg-gray-50"
                  >
                    View
                  </a> */}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Centrify>)
}

const languages = [
  {
    name: "German",
    level: "Native",
    imageUrl: german_icon
  },
  {
    name: "English",
    level: "Professional",
    imageUrl: usa_icon
  },
  {
    name: "French",
    level: "Conversational",
    imageUrl: french_icon
  },
  {
    name: "Spanish",
    level: "Foundational (actively learning)",
    imageUrl: spanish_icon
  }
]

export function Languages() {
  return (
    <Centrify>
      <h1 className="truncate text-sm font-medium text-gray-900">Languages</h1>
      <div className="mt-6 flow-root">
        <ul className="-my-5 divide-y divide-gray-200">
          {languages.map((language) => (
            <li key={language.name} className="py-4">
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <img className="h-8 w-8 rounded-full" src={language.imageUrl} alt="" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-gray-900">{language.name} | {language.level}</p>
                  {/* <p className="truncate text-sm text-gray-500">{'@' + skill.handle}</p> */}
                </div>
                <div>
                  {/* <a
                    href="#"
                    className="inline-flex items-center rounded-full border border-gray-300 bg-white px-2.5 py-0.5 text-sm font-medium leading-5 text-gray-700 shadow-sm hover:bg-gray-50"
                  >
                    View
                  </a> */}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Centrify>)
}